module.exports = __webpack_public_path__ + "img/takahsshi_s.11906956.png";